function showProgressBar() {
  const progressBar = document.querySelector(".c-progress-bar");
  
  setTimeout(() => {
    progressBar?.classList.add("c-progress-bar-loaded");
  }, 400);
}

// Set progress bar height to MainContent height, progress path height in vh based on scroll
function updateProgressBar() {
  const progressBar = document.querySelector(".c-progress-bar");
  const progressPath = document.querySelector(".c-progress-path");
  const mainContent = document.getElementById("MainContent");
  if (!progressBar || !progressPath || !mainContent) return;

  const mainContentHeight = mainContent.offsetHeight;

  // Set progress bar height to match MainContent
  progressBar.style.height = `${mainContentHeight}px`;

  // Calculate scroll progress
  const rect = mainContent.getBoundingClientRect();
  const mainContentTop = rect.top + window.scrollY;
  const scrolledIntoMain = window.scrollY - mainContentTop;
  const scrollableHeight = mainContentHeight - window.innerHeight;

  // Clamp between 0 and 100
  const scrollPercent = Math.min(
    100,
    Math.max(0, (scrolledIntoMain / scrollableHeight) * 100),
  );

  // Map scroll progress (0-100) to height range (11vh - 80vh)
  const minHeight = 11;
  const maxHeight = 80;
  const heightVh = minHeight + (scrollPercent / 100) * (maxHeight - minHeight);

  progressPath.style.height = `${heightVh}vh`;
}

// Toggle the van wobble animation on while the user is actively scrolling.
// `scrollend` fires after the scroll has settled; the timeout fallback covers
// browsers that don't support it yet (older Safari).
let scrollIdleTimer;
let lastScrollY = window.scrollY;
function handleScroll() {
  updateProgressBar();
  const progressVan = document.querySelector(".c-progress-van");
  if (!progressVan) return;
  progressVan.classList.add("c-progress-van-animation");

  const currentScrollY = window.scrollY;
  if (currentScrollY > lastScrollY) {
    progressVan.classList.add("scrolling-down");
    progressVan.classList.remove("scrolling-up");
  } else if (currentScrollY < lastScrollY) {
    progressVan.classList.add("scrolling-up");
    progressVan.classList.remove("scrolling-down");
  }
  lastScrollY = currentScrollY;

  clearTimeout(scrollIdleTimer);
  scrollIdleTimer = setTimeout(() => {
    progressVan.classList.remove("c-progress-van-animation", "scrolling-down", "scrolling-up");
  }, 150);
}

window.addEventListener("scroll", handleScroll, { passive: true });
window.addEventListener("DOMContentLoaded", () => { showProgressBar(); updateProgressBar(); });
window.addEventListener("resize", updateProgressBar);
